import {de_DE_informal} from '@App/locales/de_DE-informal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const repareo = {
    translation: {
        ...de_DE_informal.translation,
        ...de_DE_globalTranslations.translation,
        ...{
            hero: {
                ...de_DE_informal.translation.hero,
                ...{
                    'title': 'Willkommen bei der Werkstatt-Buchung von {{organization}}',
                    'subtitle': null,
                }
            },
            welcomeModal: {
                ...de_DE_informal.translation.welcomeModal,
                ...{
                    'title': null,
                    'text': null,
                }
            },
            contactForm: {
                ...de_DE_informal.translation.contactForm,
                ...{
                    'number-plate-label': 'Wie lautet dein KFZ-Kennzeichen?',
                }
            },
            contactFormMessages: {
                'activeInquiryExistsForNumberplateErrorMessageTitle': 'Sie haben bereits einen Termin',
                'activeInquiryExistsForNumberplateAndServiceErrorMessageTitle': 'Sie haben bereits einen Termin für diesen Service',
                'returnDateNotReachedTitle': 'Rückgabe ist zu früh geplant',
                'returnDateNotReached': `Ihr Fahrzeug ist noch nicht für die Rückgabe freigegeben. <br/> Frühestes  Rückgabedatum: {{returnDate}}`,
                'numberplateCorrect': 'Kennzeichen stimmt',
                'numberplateChange': 'Kennzeichen ändern',
                'numberplateNotFoundTitle': 'Kennzeichen nicht gefunden',
                'numberplateNotFoundMessage': `Wir konnten Ihr Fahrzeug nicht im Leasing-Bestand finden. <br/> Bitte prüfen Sie das angegebene Kennzeichen.`,
                'slotAlreadyTakenTitle': ' Oh! Da war jemand schneller',
                'nationwideServiceAddressHeadline': 'Wo soll der Service durchgeführt werden?',
                'wheeSizeDisclaimer': 'Bitte teilen Sie uns Ihre Reifengröße mit, um Rückfragen von der Werkstatt zu vermeiden. Damit die Werkstatt Ihren gewünschten Service umsetzen kann, benötigt diese zeitnah im Vorfeld ein Bild Ihres Fahrzeugscheins. Bitte schicken Sie dieses Bild an werkstattmeister@repareo.de, wir leiten das gerne an die Werkstatt weiter.',
                'registrationDocumentDisclaimer': 'Damit die Werkstatt Ihren gewünschten Service umsetzen kann, benötigt diese zeitnah im Vorfeld ein Bild Ihres Fahrzeugscheins. Bitte schicken Sie dieses Bild an werkstattmeister@repareo.de, wir leiten das gerne an die Werkstatt weiter.'
            }
        }
    }
}
